import HomeCard from "../../../UI/HomeCard";
import { SiGooglecloud } from "react-icons/si";

const Cloud = () => {
  return (
    <HomeCard>
      <h2>
        <SiGooglecloud /> DevOps & Cloud (Learning & Growing)
      </h2>

      <p>
        I have a basic understanding of DevOps and cloud concepts and I’m
        actively exploring them day by day. Alongside my frontend-focused work,
        I’m learning how modern applications are deployed, monitored, and
        managed in cloud environments.
      </p>

      <div>
        What I’m currently working on and learning:
        <ul>
          <li>Setting up basic CI/CD pipelines using GitHub Actions</li>
          <li>
            Understanding cloud fundamentals using AWS (compute, storage,
            deployment basics)
          </li>
          <li>
            Using Docker at a basic level for local development and simple
            deployments
          </li>
          <li>
            Learning deployment workflows for frontend and full-stack
            applications
          </li>
          <li>
            Continuously improving my understanding of DevOps best practices
          </li>
        </ul>
      </div>
    </HomeCard>
  );
};

export default Cloud;
